<template>
  <div class="payInfo">
    <QS-h4-title title="银行账户信息" />
    <QS-column-box
      :source="source"
      :list="list"
      :column="3"
      labelWidth="150"
      separator=":"
    >
      <template slot="bankPic">
        <EnlargeImg :imgSrc="source.bankPic||''" class="avatar" />
      </template>
    </QS-column-box>
  </div>
</template>

<script>
export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.payInfo{

}
</style>
